import { Pipe, PipeTransform } from "@angular/core";
import { isMetric, UnitSystem, UnitType } from "./measurement.type";

@Pipe({
  name: 'convert',
  standalone: true
})
export class ConvertMeasure implements PipeTransform {
  readonly inchScale = 25.4;
  readonly SquareInchScale = Math.pow(this.inchScale, 2);

  transform(value: number,  system: UnitSystem, type: UnitType = 'length') {
    if (!isMetric(system)) {
      return type == 'area' ? value / this.SquareInchScale : value / this.inchScale;
    }
    return value;
  }

}
